module.exports = __webpack_public_path__ + "img/intro_dot.72f2ba37.png";